<template>
  <v-container class="grey lighten-5">
    <v-row class="justify-start">
      <div class="accordeon-container">
        <div class="d-flex flex-row align-center justify-space-between px-5 py-2 mt-3">
          <div class="d-flex align-center">
            <div
              style="cursor: pointer"
              @click="isVisibilt = !isVisibilt"
              class="d-flex align-center px-2 py-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="13.351"
                viewBox="0 0 22 13.351"
              >
                <path
                  id="Icon_awesome-chevron-down"
                  data-name="Icon awesome-chevron-down"
                  d="M10.543,21.68.752,11.889a1.209,1.209,0,0,1,0-1.71L1.894,9.037a1.209,1.209,0,0,1,1.708,0l7.8,7.759,7.8-7.759a1.209,1.209,0,0,1,1.708,0l1.142,1.142a1.209,1.209,0,0,1,0,1.71L12.253,21.68A1.209,1.209,0,0,1,10.543,21.68Z"
                  transform="translate(-0.398 -8.683)"
                  fill="#6f6f6f"
                />
              </svg>
            </div>
            <h3 class="color-darkGray">{{ cardType }}</h3>
          </div>
          <v-btn
            v-if="type === 'Sepa'"
            class="br-8"
            height="40"
            color="secondary"
            small
            @click="addCard"
            >Adicionar SEPA</v-btn
          >
          <v-btn v-else class="br-8" height="40" color="secondary" small @click="addCard"
            >Adicionar Cartão</v-btn
          >
        </div>
        <template v-if="isVisibilt">
          <div
            class="d-flex flex-row align-center justify-space-between px-5 py-2 mt-3"
            v-for="(item, index) in itens"
            :key="index + '_card'"
          >
            <div class="d-flex flex-column align-start justify-center">
              <p class="ma-0 f-990 color-darkGray">{{ type === 'Sepa' ? 'Nome' : 'Número' }}</p>
              <div class="d-flex flex-row align-center justify-center">
                <p
                  v-if="type === 'Sepa'"
                  class="ma-0 f-12 primary--text font-weight-medium valor-cartao"
                >
                  {{ maskName(item.account_name) }}
                </p>
                <p v-else class="ma-0 f-12 primary--text font-weight-medium valor-cartao">
                  {{ `**** ${item.number}` }}
                </p>
              </div>
            </div>
            <div class="d-flex flex-column align-start justify-center">
              <p class="ma-0 f-990 color-darkGray">{{ type === 'Sepa' ? 'IBAN' : 'Validade' }}</p>
              <p
                v-if="type === 'Sepa'"
                class="ma-0 f-12 primary--text font-weight-medium valor-cartao"
              >
                **** {{ item.iban_code.substring(item.iban_code.length - 4) }}
              </p>
              <p v-else class="ma-0 f-12 primary--text font-weight-medium valor-cartao">
                {{ item.due_date }}
              </p>
            </div>
            <div class="d-flex flex-column flex-md-row align-center justify-center">
              <ModalDialog @remove="deletePatientCard(item)" :item="item" :type="type" />
            </div>
          </div>
        </template>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import ModalDialog from './RemoveModalDialog.vue';

export default {
  name: 'CardListPayment',
  components: {
    ModalDialog,
  },
  props: {
    cardType: { type: String },
    itens: { type: Array },
    type: { type: String },
    editCreditCard: { type: Function },
  },
  data() {
    return {
      isVisibilt: false,
    };
  },
  methods: {
    addCard() {
      this.$emit('addCard');
    },
    deletePatientCard(item) {
      this.$emit('remove', item);
    },
    maskName(name) {
      const nameList = name.split(' ');
      const endIndex = nameList.length - 1;
      return nameList
        .map((v, i) => {
          if (i == 0) {
            return v;
          }
          if (i === endIndex) {
            return (i = '...');
          }
          return `${String(v).charAt(0)}.`;
        })
        .join(' ');
    },
  },
};
</script>

<style scoped>
.accordeon-container {
  width: 100%;
  max-width: 526px;
  background-color: #fffde3;
}
</style>
